import { UrlMatchResult, UrlSegment } from '@angular/router';

export const tabsRouteMatcher = (segments: UrlSegment[]): UrlMatchResult | null => {
  if (segments.length >= 1 && segments.length <= 2) {
    const posParams: { [key: string]: UrlSegment } = {};

    if (segments.length > 0) {
      posParams['tab'] = segments[0];
    }

    if (segments.length > 1) {
      posParams['subTab'] = segments[1];
    }

    return {
      consumed: segments,
      posParams,
    };
  }

  return null;
};
